import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {get as _get} from 'lodash';

import {getLink} from '@appComponents/Link';
import {convertToInt} from '@utils/helpers';
import mapModulesToProps from '@utils/mapModulesToProps';
import {PRODUCT_THIRD_PARTY} from '@constants/variables';

import ClientProductForm from './ClientProductForm';
import {deleteSuccessCallback, setClientProductsEntity} from '../utils/clientProducts';

class ClientProductThirdPartyForm extends ClientProductForm {
    componentDidMount() {
        super.componentDidMount();

        const entityName = 'client',
            params = {
                clientData: this.props.clientData,
                entityName,
                setEntity: this.props.Entity.setEntity,
            };

        this.setCreateSuccessCallback((response) => {
            const responseData = response.data.createClientProductThirdParty,
                clientProductThirdParty = {...responseData.client_product,
                    third_party_client_product: {
                        id: responseData.id,
                        third_party_client_types: responseData.third_party_client_types,
                    },
                };

            this.props.Entity.setEntity({
                name: entityName,
                data: {...this.props.clientData,
                    clientProducts: this.props.clientData.clientProducts.concat(clientProductThirdParty),
                },
            });

            this.props.history.push(getLink('clients.products.thirdParty.editGeoRestrictions', {
                id: this.props.match.params.id,
            }));
        });

        this.setUpdateSuccessCallback((response) => {
            const responseData = response.data.updateClientProductThirdParty,
                clientProductThirdPartyIndex = this.props.clientData.clientProducts.findIndex(clientProduct =>
                    PRODUCT_THIRD_PARTY === convertToInt(clientProduct.product.id)
                ),
                clientProducts = {};

            clientProducts[clientProductThirdPartyIndex] = {
                ...responseData.client_product,
                third_party_client_product: {
                    id: responseData.id,
                    third_party_client_types: responseData.third_party_client_types,
                },
            };
            params.clientProducts = clientProducts;

            setClientProductsEntity(params);
        });

        this.setDeleteSuccessCallback(() => {
            params.formParamsId = this.props.formParams.id;
            params.historyPush = this.props.history.push;

            deleteSuccessCallback(params);
        });
    }

    componentDidUpdate(prevProps) {
        const {
            formParams,
            GraphQLEntityData,
            GraphQLOptionsData,
        } = this.props;

        const isAddForm = _get(formParams, 'isAddForm');
        const clientProductsThirdParty = _get(GraphQLEntityData, 'clientProductsThirdParty', []);
        const entityLoading = _get(GraphQLEntityData, 'loading', false);
        const thirdPartyClientTypes = _get(GraphQLOptionsData, 'thirdPartyClientTypes', []);
        const optionsProduct = _get(GraphQLOptionsData, 'product');
        const optionsLoading = _get(GraphQLOptionsData, 'loading', false);
        let augmentedPrevProps = prevProps;

        if (!optionsLoading && !entityLoading && !this.state.dataReceived) {
            if (!isAddForm && 0 < clientProductsThirdParty.length) {
                augmentedPrevProps = { ...prevProps, clientProduct: clientProductsThirdParty[0].client_product };

                this.setField('id', {defaultValue: convertToInt(clientProductsThirdParty[0].id)});
                this.setField('third_party_client_types', {
                    defaultValue: clientProductsThirdParty[0].third_party_client_types.map(thirdPartyClientType =>
                        convertToInt(thirdPartyClientType.id)
                    ),
                    options: thirdPartyClientTypes,
                });
            }

            this.handleInitialSlaFieldVisibility(isAddForm, clientProductsThirdParty, optionsProduct);
            super.componentDidUpdate(augmentedPrevProps);
        }
    }

    prepareDataForSubmit(data) {
        data = {...data, product: PRODUCT_THIRD_PARTY};

        const dataToSubmit = super.prepareDataForSubmit(data);

        return {...dataToSubmit, third_party_client_types: data.third_party_client_types};
    }
}

const mapDispatchToProps = mapModulesToProps(['Entity']),
    mapStateToProps = (state) => ({clientData: state.app.entities.client || null});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ClientProductThirdPartyForm));
